import LinkResult from './LinkResult';

export default LinkResult;
